import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { onMounted, computed, ref, watch } from 'vue';
import { usePreferencesStore } from '@/store/preferences';
import { useModuleLayoutFetcher } from '@/composables/useModuleLayoutFetcher';
import { HEADERS, DEFAULT_HEADER_ORDER } from '@/components/listing/posters/posters.config';
import Table from '@/components/views/TableView.vue';
import Filter from '@/components/drawer/Filters.vue';
import ViewsContainer from '@/components/views/ViewsContainer.vue';
import { apiClient } from '@/plugins/axios';
import { configRegistry } from '@/lib/configRegistry';


export default /*@__PURE__*/_defineComponent({
  __name: 'Posters',
  props: {
    item: {}
  },
  setup(__props: any) {

const props = __props;

/** 1) moduleName único por instancia */
const moduleKey = computed(() => `Posters#${props.item?.id ?? 'na'}`);

/** 2) alias en configRegistry para ese moduleKey */
function ensureConfigAlias() {
  // Reusa exactamente la misma config de "Posters"
  if (!configRegistry[moduleKey.value]) {
    configRegistry[moduleKey.value] = configRegistry['Posters'];
  }
}

/** 3) data local por instancia */
const rows = ref<any[]>([]);

const preferencesStore = usePreferencesStore();

/** fetcher local: no usa el store global para evitar colisiones */
async function fetchScopedPosters(params: any): Promise<{ data: any[]; total: number }> {
  const resp = await apiClient.get('/posters', {
    params: {
      ...params,
      'filter[product_id]': props.item?.id,  // fija el scope
    },
  });
  const data = resp.data?.data || [];
  const total = resp.data?.meta?.total ?? data.length;
  rows.value = data;                          // alimenta la tabla de esta instancia
  return { data, total };
}

/** Hook de layout/paginación/sort, con moduleKey único */
const { create, update, remove } = useModuleLayoutFetcher(
  moduleKey.value,                // <- módulo distinto por detalle
  (params) => fetchScopedPosters(params),
  {
    // Si usas create/update/delete aquí, basta con que dejes que useModuleLayoutFetcher haga reload()
    create: async (payload) => {
      const r = await apiClient.post('/posters', payload);
      return r.data;
    },
    update: async (data) => {
      const r = await apiClient.patch(`/posters/${data.id}`, data);
      return r.data;
    },
    remove: async (id) => {
      await apiClient.delete(`/posters/${id}`);
      return { success: true };
    },
  }
);

onMounted(() => {
  ensureConfigAlias();                              // apunta "Posters#ID" a la misma config
  preferencesStore.currentModule = moduleKey.value; // headers/prefs separados por instancia
  preferencesStore.setAllModuleHeaders(moduleKey.value, HEADERS);
  preferencesStore.setDefaultModuleHeaders(
    moduleKey.value,
    DEFAULT_HEADER_ORDER
      .map(v => HEADERS.find(h => h.value === v))
      .filter(Boolean) as typeof HEADERS
  );
});

/** Si cambiara el item.id (raro), rehace alias y prefs */
watch(() => props.item?.id, () => {
  ensureConfigAlias();
  preferencesStore.currentModule = moduleKey.value;
});

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(ViewsContainer, {
        moduleName: moduleKey.value,
        listViewComponent: Table,
        filterComponent: Filter,
        data: rows.value,
        product_id: _ctx.item?.id,
        medium: _ctx.item?.attributes?.additional_data?.type,
        config: '@/components/listing/posters/posters.config',
        onCreate: _unref(create),
        onUpdate: _unref(update),
        onDelete: _unref(remove),
        rowActionHandlers: _ctx.rowActionHandlers,
        show_toolbar: true,
        show_pagination: true,
        title: { singular: 'Poster', plural: 'Posters' },
        key: moduleKey.value
      }, null, 8, ["moduleName", "data", "product_id", "medium", "onCreate", "onUpdate", "onDelete", "rowActionHandlers"]))
    ]),
    _: 1
  }))
}
}

})